import {
  PRIORITIZED_DISPLAYABLE_CASH_CROPS_WITH_PREVENT_PLANT,
  PRIORITIZED_DISPLAYABLE_CASH_CROPS_WITHOUT_FALLOW,
  PRIORITY_CASH_CROPS,
  RDCashCropSpecies,
} from '@cibo/core'
import { useCiboAutoForm } from '@cibo/ui'
import {
  Autocomplete,
  AutocompleteRenderInputParams,
  Collapse,
  FormControl,
  FormLabel,
  TextField,
} from '@mui/material'
import { useTranslation } from 'react-i18next'

import { connectField, filterDOMProps, useForm } from 'uniforms'

export const CashCropInput = (props: any) => {
  const { name, label, required, disabled } = props

  const { t } = useTranslation('@cibo/landmanager/CashCropEditor')
  const { t: cropT } = useTranslation('@cibo/ui/cropNames')

  const { model, onChange } = useForm()
  const { touch } = useCiboAutoForm()

  const modelIsPreventPlant = (model.value as { preventPlant?: boolean })?.preventPlant

  return (
    <>
      <FormControl fullWidth {...filterDOMProps(props)} required={required} disabled={disabled}>
        <FormLabel component="legend" htmlFor={name}>
          {label || t('title')}
        </FormLabel>

        <Autocomplete
          renderInput={(params: AutocompleteRenderInputParams) => (
            <TextField name={name} {...params} />
          )}
          groupBy={(crop: RDCashCropSpecies | 'preventPlant') =>
            PRIORITY_CASH_CROPS.includes(crop as RDCashCropSpecies) ? t('suggested') : t('all')
          }
          options={PRIORITIZED_DISPLAYABLE_CASH_CROPS_WITH_PREVENT_PLANT}
          getOptionLabel={(option: unknown) => cropT(option as string)}
          data-testid={`crop`}
          selectOnFocus
          onChange={(_, newValue) => {
            const newValueIsPreventPlant = newValue === 'preventPlant'

            try {
              // @ts-ignore 'preventPlant' is not always in the schema
              onChange('value.preventPlant', newValueIsPreventPlant)
            } catch (error) {
              // Ignore error since this could be a "results only" string value with no preventPlant
            }

            if (newValueIsPreventPlant) {
              // clear for "intended crop"
              onChange(name, undefined)
            } else {
              onChange(name, newValue === null ? undefined : newValue)
            }
          }}
          value={modelIsPreventPlant ? 'preventPlant' : props.value || ''}
          onBlur={() => touch(name)}
        />
      </FormControl>

      <Collapse in={modelIsPreventPlant}>
        <FormControl fullWidth {...filterDOMProps(props)} required={required} disabled={disabled}>
          <FormLabel htmlFor={name} component="legend">
            {t('intendedCrop')}
          </FormLabel>

          <Autocomplete
            renderInput={(params: AutocompleteRenderInputParams) => (
              <TextField name={name} {...params} />
            )}
            groupBy={(crop: RDCashCropSpecies) =>
              PRIORITY_CASH_CROPS.includes(crop) ? t('suggested') : t('all')
            }
            options={PRIORITIZED_DISPLAYABLE_CASH_CROPS_WITHOUT_FALLOW}
            getOptionLabel={(option: unknown) => cropT(option as string)}
            data-testid={`intendedCrop`}
            selectOnFocus
            onChange={(_, value) => {
              onChange('value.crop', value)
            }}
            value={modelIsPreventPlant ? props.value : ''}
          />
        </FormControl>
      </Collapse>
    </>
  )
}

export const CashCropField = connectField(CashCropInput)
